/* ============================================================
   Dashboard — Home view
   Wired to mock data shaped EXACTLY like the real API response
   ============================================================ */

import React, { useState } from 'react';
import { Wordmark, Icon } from '../components/shared.jsx';

const MOCK_DASHBOARD = {
  client: {
    name: 'Julio Arroyo',
    email: 'direccion@autopaquete.com',
    balance: '14890.29',
    company_name: 'Planeta Envios',
  },
  statistics: {
    total_policies: 4392,
    total_insured_amount: '17449477.00',
    active_policies: 3812,
    expired_policies: 412,
    pending_policies: 168,
    open_claims: 7,
    insured_this_month: '2384210.00',
    policies_this_month: 612,
    monthly_change_pct: 12.4,
    avg_premium: '24.85',
  },
  latest_transactions: [
    { description: 'Se emitió la constancia de protección AP4513', type: 'withdrawal', amount: '25.00', balance: '14890.29', created_at: '2026-05-01T21:12:03.000000Z' },
    { description: 'Reembolso por constancia fallida AP4512', type: 'deposit', amount: '25.00', balance: '14915.29', created_at: '2026-05-01T21:06:51.000000Z' },
    { description: 'Se emitió la constancia de protección AP4512', type: 'withdrawal', amount: '25.00', balance: '14890.29', created_at: '2026-05-01T21:06:50.000000Z' },
    { description: 'Reembolso por constancia fallida AP4511', type: 'deposit', amount: '25.00', balance: '14915.29', created_at: '2026-05-01T21:06:18.000000Z' },
    { description: 'Se emitió la constancia de protección AP4511', type: 'withdrawal', amount: '25.00', balance: '14890.29', created_at: '2026-05-01T21:06:17.000000Z' },
  ],
  recent_policies: [
    { id: 'AP4513', carrier: 'FedEx', tracking: '284512938401', value: 12500, premium: 25.00, status: 'active',  created_at: '2026-05-01T21:12:03Z', recipient: 'María González' },
    { id: 'AP4512', carrier: 'DHL',   tracking: '7849210034',  value:  8900, premium: 18.50, status: 'failed',   created_at: '2026-05-01T21:06:50Z', recipient: 'Roberto Tovar' },
    { id: 'AP4511', carrier: 'Estafeta', tracking: '13942784123', value: 4200, premium: 12.00, status: 'active', created_at: '2026-05-01T21:06:17Z', recipient: 'Ana Rivera' },
    { id: 'AP4510', carrier: 'FedEx',  tracking: '284512938400', value: 24800, premium: 38.20, status: 'active', created_at: '2026-05-01T20:48:11Z', recipient: 'Daniel López' },
    { id: 'AP4509', carrier: 'Paquetexpress', tracking: 'PX9923847', value: 1850, premium: 8.50, status: 'delivered', created_at: '2026-05-01T19:22:45Z', recipient: 'Sofía Méndez' },
    { id: 'AP4508', carrier: 'DHL',   tracking: '7849210033', value: 32000, premium: 48.00, status: 'active',    created_at: '2026-05-01T18:14:02Z', recipient: 'Carlos Ramírez' },
    { id: 'AP4507', carrier: 'Estafeta', tracking: '13942784122', value: 6700, premium: 15.20, status: 'in_transit', created_at: '2026-05-01T17:33:21Z', recipient: 'Lucía Vázquez' },
  ],
  monthly_chart: [
    { m: 'Nov', policies: 412, amount: 1842000 },
    { m: 'Dic', policies: 489, amount: 2104000 },
    { m: 'Ene', policies: 521, amount: 2298000 },
    { m: 'Feb', policies: 478, amount: 2187000 },
    { m: 'Mar', policies: 542, amount: 2456000 },
    { m: 'Abr', policies: 588, amount: 2732000 },
    { m: 'May', policies: 612, amount: 2384210 },
  ],
  active_claims: [
    { id: 'CLM-0042', policy: 'AP4498', reason: 'Daño en tránsito', amount: 8400, status: 'review',     opened_at: '2026-04-29' },
    { id: 'CLM-0041', policy: 'AP4486', reason: 'Extravío',         amount: 2200, status: 'evidence',  opened_at: '2026-04-27' },
    { id: 'CLM-0040', policy: 'AP4471', reason: 'Robo',             amount: 15600, status: 'approved', opened_at: '2026-04-25' },
  ],
};

function fmtMoney(n, currency = 'MXN') {
  const num = typeof n === 'string' ? parseFloat(n) : n;
  return new Intl.NumberFormat('es-MX', { style: 'currency', currency, maximumFractionDigits: 2 }).format(num);
}
function fmtNum(n) {
  return new Intl.NumberFormat('es-MX').format(n);
}
function fmtDate(iso) {
  const d = new Date(iso);
  return d.toLocaleString('es-MX', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' });
}
function relTime(iso) {
  const diff = (Date.now() - new Date(iso).getTime()) / 1000;
  if (diff < 60) return 'hace un momento';
  if (diff < 3600) return `hace ${Math.floor(diff/60)} min`;
  if (diff < 86400) return `hace ${Math.floor(diff/3600)} h`;
  return `hace ${Math.floor(diff/86400)} d`;
}

// ===== Sidebar =====
function Sidebar({ user, onLogout }) {
  const items = [
    { icon: 'home',   label: 'Resumen',         active: true },
    { icon: 'shield', label: 'Protecciones',         badge: '4,392' },
    { icon: 'plus',   label: 'Nueva protección' },
    { icon: 'users',  label: 'Beneficiarios' },
    { icon: 'alert-triangle', label: 'Reclamaciones', badge: '7' },
    { icon: 'wallet', label: 'Facturación' },
    { icon: 'chart',  label: 'Reportes' },
  ];
  const bottom = [
    { icon: 'code',     label: 'API & Webhooks' },
    { icon: 'book',     label: 'Documentación' },
    { icon: 'settings', label: 'Configuración' },
  ];
  const initials = user.name.split(' ').map(s=>s[0]).slice(0,2).join('');
  return (
    <aside className="r-dash-sidebar" style={{
      width: 256, background: 'var(--bg)', borderRight: '1px solid var(--border)',
      display: 'flex', flexDirection: 'column',
      position: 'sticky', top: 0, height: '100vh',
      flexShrink: 0,
    }}>
      <div style={{ padding: '20px 20px 16px' }}>
        <Wordmark height={26}/>
      </div>

      <div style={{ padding: '0 12px', marginTop: 8 }}>
        <button style={{
          width: '100%', padding: '10px 12px',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          background: 'var(--bg-muted)', border: '1px solid var(--border-faint)',
          borderRadius: 8, cursor: 'pointer', textAlign: 'left',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, minWidth: 0 }}>
            <div style={{
              width: 24, height: 24, borderRadius: 5,
              background: 'linear-gradient(135deg, var(--brand-3), var(--brand))',
              color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 11, fontWeight: 700, letterSpacing: '-0.02em',
            }}>{user.company_name.slice(0,2).toUpperCase()}</div>
            <div style={{ minWidth: 0 }}>
              <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--fg)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {user.company_name}
              </div>
              <div className="text-mono" style={{ fontSize: 10, color: 'var(--fg-muted)' }}>Producción</div>
            </div>
          </div>
          <Icon name="chevron-down" size={14} color="var(--fg-muted)"/>
        </button>
      </div>

      <nav style={{ padding: '20px 12px 12px', flex: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
        <div className="text-mono" style={{ fontSize: 10, textTransform: 'uppercase', letterSpacing: '0.1em', color: 'var(--fg-muted)', padding: '8px 12px 6px' }}>
          Principal
        </div>
        {items.map((it, i) => <NavItem key={i} {...it}/>)}

        <div className="text-mono" style={{ fontSize: 10, textTransform: 'uppercase', letterSpacing: '0.1em', color: 'var(--fg-muted)', padding: '20px 12px 6px' }}>
          Desarrollo
        </div>
        {bottom.map((it, i) => <NavItem key={i} {...it}/>)}
      </nav>

      <div style={{ padding: 12, borderTop: '1px solid var(--border-faint)' }}>
        <div style={{
          display: 'flex', alignItems: 'center', gap: 10, padding: 8,
          borderRadius: 8,
        }}>
          <div style={{
            width: 32, height: 32, borderRadius: '50%',
            background: 'linear-gradient(135deg, #6366f1, #1e40af)',
            color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 12, fontWeight: 600,
          }}>{initials}</div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: 13, fontWeight: 600, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {user.name}
            </div>
            <div className="text-mono" style={{ fontSize: 11, color: 'var(--fg-muted)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {user.email}
            </div>
          </div>
          <button onClick={onLogout} style={{
            background: 'transparent', border: 'none', cursor: 'pointer',
            color: 'var(--fg-muted)', padding: 6, borderRadius: 6,
          }} title="Cerrar sesión">
            <Icon name="logout" size={16}/>
          </button>
        </div>
      </div>
    </aside>
  );
}

function NavItem({ icon, label, badge, active }) {
  return (
    <a href="#" style={{
      display: 'flex', alignItems: 'center', gap: 10, padding: '8px 12px',
      borderRadius: 6, fontSize: 13, fontWeight: 500,
      color: active ? 'var(--brand)' : 'var(--fg-secondary)',
      background: active ? 'var(--brand-soft)' : 'transparent',
      transition: 'all 0.12s ease',
    }} onMouseEnter={e => { if(!active) e.currentTarget.style.background = 'var(--bg-muted)'; }}
       onMouseLeave={e => { if(!active) e.currentTarget.style.background = 'transparent'; }}>
      <Icon name={icon} size={16}/>
      <span style={{ flex: 1 }}>{label}</span>
      {badge && (
        <span className="text-mono" style={{
          fontSize: 10, padding: '2px 6px', borderRadius: 4,
          background: active ? 'rgba(30,64,175,0.15)' : 'var(--bg-muted)',
          color: active ? 'var(--brand)' : 'var(--fg-muted)',
          fontWeight: 500,
        }}>{badge}</span>
      )}
    </a>
  );
}

// ===== Topbar =====
function Topbar({ user }) {
  return (
    <header className="r-dash-topbar" style={{
      height: 64, borderBottom: '1px solid var(--border)',
      padding: '0 32px',
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      background: 'rgba(255,255,255,0.85)', backdropFilter: 'saturate(180%) blur(12px)',
      position: 'sticky', top: 0, zIndex: 10,
    }}>
      <div className="r-hide-mobile" style={{ display: 'flex', alignItems: 'center', gap: 16, flex: 1 }}>
        <div style={{ position: 'relative', maxWidth: 360, width: '100%' }}>
          <Icon name="search" size={15} color="var(--fg-muted)"
                style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)' }}/>
          <input className="input" placeholder="Buscar protecciones, beneficiarios, tracking…"
                 style={{ paddingLeft: 36, fontSize: 13 }}/>
          <span className="text-mono" style={{
            position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)',
            fontSize: 10, color: 'var(--fg-muted)',
            border: '1px solid var(--border)', borderRadius: 4,
            padding: '2px 6px', background: 'var(--bg-muted)',
          }}>⌘K</span>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <span className="r-hide-mobile pill text-mono" style={{ fontSize: 11 }}>
          <span style={{ width: 6, height: 6, borderRadius: '50%', background: 'var(--success)' }}/>
          API operativa
        </span>
        <button className="btn btn-ghost btn-sm" style={{ padding: 8, position: 'relative' }}>
          <Icon name="bell" size={16}/>
          <span style={{
            position: 'absolute', top: 6, right: 6, width: 7, height: 7,
            borderRadius: '50%', background: 'var(--danger)',
            border: '2px solid var(--bg)',
          }}/>
        </button>
        <button className="btn btn-primary btn-sm">
          <Icon name="plus" size={14}/> Nueva protección
        </button>
      </div>
    </header>
  );
}

// ===== Stat card =====
function StatCard({ label, value, change, icon, sub, color }) {
  const positive = change && change > 0;
  return (
    <div className="card" style={{ padding: 24 }}>
      <div className="flex items-center justify-between" style={{ marginBottom: 20 }}>
        <div style={{
          width: 36, height: 36, borderRadius: 8,
          background: color ? `${color}15` : 'var(--brand-soft)',
          color: color || 'var(--brand)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          <Icon name={icon} size={18}/>
        </div>
        {change !== undefined && (
          <span className="text-mono" style={{
            fontSize: 12, fontWeight: 500,
            color: positive ? 'var(--success)' : 'var(--danger)',
            display: 'inline-flex', alignItems: 'center', gap: 4,
          }}>
            <Icon name={positive ? 'arrow-up-right' : 'arrow-down'} size={12}/>
            {Math.abs(change).toFixed(1)}%
          </span>
        )}
      </div>
      <div className="text-mono" style={{
        fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.08em',
        color: 'var(--fg-muted)', marginBottom: 8,
      }}>{label}</div>
      <div style={{ fontSize: 30, fontWeight: 600, letterSpacing: '-0.025em', color: 'var(--fg)', lineHeight: 1.1 }}>
        {value}
      </div>
      {sub && <div style={{ fontSize: 13, color: 'var(--fg-muted)', marginTop: 6 }}>{sub}</div>}
    </div>
  );
}

// ===== Monthly chart (SVG) =====
function MonthlyChart({ data }) {
  const w = 720, h = 240, pad = { l: 40, r: 16, t: 20, b: 30 };
  const innerW = w - pad.l - pad.r, innerH = h - pad.t - pad.b;
  const max = Math.max(...data.map(d => d.amount));
  const xStep = innerW / (data.length - 1);
  const points = data.map((d, i) => ({
    x: pad.l + i * xStep,
    y: pad.t + innerH - (d.amount / max) * innerH,
    ...d,
  }));
  const linePath = points.map((p, i) => `${i === 0 ? 'M' : 'L'} ${p.x} ${p.y}`).join(' ');
  const areaPath = `${linePath} L ${points[points.length-1].x} ${pad.t + innerH} L ${points[0].x} ${pad.t + innerH} Z`;

  const [hover, setHover] = useState(null);
  return (
    <div style={{ position: 'relative' }}>
      <svg viewBox={`0 0 ${w} ${h}`} width="100%" style={{ display: 'block', overflow: 'visible' }}>
        <defs>
          <linearGradient id="chartGrad" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stopColor="#1e40af" stopOpacity="0.18"/>
            <stop offset="1" stopColor="#1e40af" stopOpacity="0"/>
          </linearGradient>
        </defs>
        {/* gridlines */}
        {[0, 0.25, 0.5, 0.75, 1].map((p, i) => (
          <g key={i}>
            <line x1={pad.l} y1={pad.t + innerH * p} x2={w - pad.r} y2={pad.t + innerH * p}
                  stroke="var(--border-faint)" strokeWidth={1}/>
            <text x={pad.l - 8} y={pad.t + innerH * p + 4} textAnchor="end"
                  fontSize="10" fill="var(--fg-muted)" fontFamily="var(--font-mono)">
              ${(max * (1 - p) / 1e6).toFixed(1)}M
            </text>
          </g>
        ))}
        {/* area + line */}
        <path d={areaPath} fill="url(#chartGrad)"/>
        <path d={linePath} fill="none" stroke="var(--brand)" strokeWidth={2.2}
              strokeLinecap="round" strokeLinejoin="round"/>
        {/* points */}
        {points.map((p, i) => (
          <g key={i} onMouseEnter={() => setHover(i)} onMouseLeave={() => setHover(null)} style={{cursor:'pointer'}}>
            <rect x={p.x - xStep/2} y={pad.t} width={xStep} height={innerH} fill="transparent"/>
            <circle cx={p.x} cy={p.y} r={hover === i ? 6 : 4}
                    fill="white" stroke="var(--brand)" strokeWidth={2}/>
            <text x={p.x} y={h - 8} textAnchor="middle"
                  fontSize="11" fill={hover === i ? 'var(--fg)' : 'var(--fg-muted)'}
                  fontFamily="var(--font-mono)" fontWeight={hover === i ? 600 : 400}>
              {p.m}
            </text>
            {hover === i && (
              <g>
                <line x1={p.x} y1={pad.t} x2={p.x} y2={pad.t + innerH}
                      stroke="var(--brand)" strokeWidth={1} strokeDasharray="3 3" opacity={0.4}/>
              </g>
            )}
          </g>
        ))}
      </svg>
      {hover !== null && (
        <div style={{
          position: 'absolute',
          left: `${(points[hover].x / w) * 100}%`,
          top: `${(points[hover].y / h) * 100}%`,
          transform: 'translate(-50%, calc(-100% - 14px))',
          background: '#0b0b14', color: 'white',
          padding: '10px 14px', borderRadius: 8,
          fontSize: 12, whiteSpace: 'nowrap',
          boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
          pointerEvents: 'none',
        }}>
          <div className="text-mono" style={{ fontSize: 10, opacity: 0.7, textTransform: 'uppercase', letterSpacing: '0.08em' }}>
            {points[hover].m} 2026
          </div>
          <div style={{ fontWeight: 600, marginTop: 4 }}>{fmtMoney(points[hover].amount)}</div>
          <div style={{ fontSize: 11, opacity: 0.7, marginTop: 2 }}>{points[hover].policies} protecciones</div>
        </div>
      )}
    </div>
  );
}

// ===== Status pill helper =====
function StatusPill({ status }) {
  const map = {
    active:     { cls: 'pill-success', label: 'Activa' },
    delivered:  { cls: 'pill-success', label: 'Entregado' },
    in_transit: { cls: '',             label: 'En tránsito' },
    failed:     { cls: 'pill-danger',  label: 'Fallida' },
    expired:    { cls: 'pill-neutral', label: 'Vencida' },
    pending:    { cls: 'pill-warning', label: 'Pendiente' },
    review:     { cls: 'pill-warning', label: 'En revisión' },
    evidence:   { cls: '',             label: 'Esperando evidencia' },
    approved:   { cls: 'pill-success', label: 'Aprobada' },
  };
  const it = map[status] || { cls: 'pill-neutral', label: status };
  return <span className={`pill ${it.cls}`}>{it.label}</span>;
}

// ===== Recent policies table =====
function RecentPolicies({ rows }) {
  return (
    <div className="card" style={{ overflow: 'hidden' }}>
      <div className="flex items-center justify-between" style={{ padding: '20px 24px', borderBottom: '1px solid var(--border-faint)' }}>
        <div>
          <h3 style={{ fontSize: 16, fontWeight: 600, margin: 0, letterSpacing: '-0.01em' }}>Últimas protecciones</h3>
          <div className="text-mono" style={{ fontSize: 11, color: 'var(--fg-muted)', marginTop: 4 }}>
            Mostrando {rows.length} de 4,392
          </div>
        </div>
        <div className="flex gap-2">
          <button className="btn btn-ghost btn-sm"><Icon name="download" size={14}/> Exportar</button>
          <button className="btn btn-secondary btn-sm">Ver todas <Icon name="arrow" size={12}/></button>
        </div>
      </div>
      <div className="r-table-scroll">
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr style={{ background: 'var(--bg-soft)' }}>
            <th style={tdh}>Constancia</th>
            <th style={tdh}>Paquetería</th>
            <th style={tdh}>Tracking</th>
            <th style={tdh}>Destinatario</th>
            <th style={{...tdh, textAlign: 'right'}}>Valor</th>
            <th style={{...tdh, textAlign: 'right'}}>Costo</th>
            <th style={tdh}>Estado</th>
            <th style={{...tdh, textAlign: 'right'}}>Creada</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r, i) => (
            <tr key={r.id} style={{ borderTop: '1px solid var(--border-faint)' }}
                onMouseEnter={e => e.currentTarget.style.background = 'var(--bg-soft)'}
                onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
              <td style={tdc} className="text-mono"><strong style={{color:'var(--fg)'}}>{r.id}</strong></td>
              <td style={tdc}>{r.carrier}</td>
              <td style={tdc} className="text-mono" >{r.tracking}</td>
              <td style={tdc}>{r.recipient}</td>
              <td style={{...tdc, textAlign: 'right'}} className="text-mono">{fmtMoney(r.value)}</td>
              <td style={{...tdc, textAlign: 'right', color: 'var(--fg-muted)'}} className="text-mono">{fmtMoney(r.premium)}</td>
              <td style={tdc}><StatusPill status={r.status}/></td>
              <td style={{...tdc, textAlign: 'right', color: 'var(--fg-muted)'}}>{relTime(r.created_at)}</td>
            </tr>
          ))}
        </tbody>
      </table>
      </div>
    </div>
  );
}
const tdh = { padding: '12px 24px', textAlign: 'left', fontSize: 11, fontWeight: 500, color: 'var(--fg-muted)', textTransform: 'uppercase', letterSpacing: '0.06em', fontFamily: 'var(--font-mono)' };
const tdc = { padding: '14px 24px', fontSize: 13, color: 'var(--fg-secondary)' };

// ===== Activity feed =====
function ActivityFeed({ items }) {
  return (
    <div className="card">
      <div style={{ padding: '20px 24px 16px', borderBottom: '1px solid var(--border-faint)' }}>
        <h3 style={{ fontSize: 16, fontWeight: 600, margin: 0, letterSpacing: '-0.01em' }}>Movimientos de saldo</h3>
        <div className="text-mono" style={{ fontSize: 11, color: 'var(--fg-muted)', marginTop: 4 }}>Últimas transacciones</div>
      </div>
      <div style={{ padding: '8px 0' }}>
        {items.map((it, i) => (
          <div key={i} className="flex items-center gap-3" style={{ padding: '12px 24px' }}>
            <div style={{
              width: 32, height: 32, borderRadius: '50%',
              background: it.type === 'deposit' ? 'var(--success-soft)' : 'var(--bg-muted)',
              color: it.type === 'deposit' ? 'var(--success)' : 'var(--fg-secondary)',
              display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
            }}>
              <Icon name={it.type === 'deposit' ? 'arrow-down' : 'arrow-up-right'} size={14}/>
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: 13, color: 'var(--fg)', fontWeight: 500, whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }}>
                {it.description}
              </div>
              <div className="text-mono" style={{ fontSize: 11, color: 'var(--fg-muted)', marginTop: 2 }}>
                {fmtDate(it.created_at)}
              </div>
            </div>
            <div style={{ textAlign: 'right' }}>
              <div className="text-mono" style={{
                fontSize: 13, fontWeight: 600,
                color: it.type === 'deposit' ? 'var(--success)' : 'var(--fg)',
              }}>
                {it.type === 'deposit' ? '+' : '−'}{fmtMoney(it.amount)}
              </div>
              <div className="text-mono" style={{ fontSize: 11, color: 'var(--fg-muted)', marginTop: 2 }}>
                Saldo: {fmtMoney(it.balance)}
              </div>
            </div>
          </div>
        ))}
      </div>
      <div style={{ padding: '12px 24px', borderTop: '1px solid var(--border-faint)' }}>
        <a href="#" style={{ fontSize: 13, color: 'var(--brand)', fontWeight: 500 }}>
          Ver historial completo →
        </a>
      </div>
    </div>
  );
}

// ===== Active claims =====
function ActiveClaims({ items }) {
  return (
    <div className="card">
      <div className="flex items-center justify-between" style={{ padding: '20px 24px 16px', borderBottom: '1px solid var(--border-faint)' }}>
        <div>
          <h3 style={{ fontSize: 16, fontWeight: 600, margin: 0, letterSpacing: '-0.01em' }}>Reclamaciones activas</h3>
          <div className="text-mono" style={{ fontSize: 11, color: 'var(--fg-muted)', marginTop: 4 }}>{items.length} abiertas · 4 cerradas este mes</div>
        </div>
        <a href="#" className="btn btn-ghost btn-sm">Ver todas</a>
      </div>
      <div>
        {items.map((it, i) => (
          <div key={it.id} className="flex items-center gap-4" style={{ padding: '16px 24px', borderTop: i ? '1px solid var(--border-faint)' : 'none' }}>
            <div style={{
              width: 36, height: 36, borderRadius: 8,
              background: 'var(--warning-soft)', color: 'var(--warning)',
              display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
            }}>
              <Icon name="alert-triangle" size={16}/>
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div className="flex items-center gap-2" style={{ marginBottom: 4 }}>
                <span className="text-mono" style={{ fontSize: 13, fontWeight: 600 }}>{it.id}</span>
                <span style={{ fontSize: 12, color: 'var(--fg-muted)' }}>·</span>
                <span style={{ fontSize: 13, color: 'var(--fg-secondary)' }}>{it.reason}</span>
              </div>
              <div className="text-mono" style={{ fontSize: 11, color: 'var(--fg-muted)' }}>
                Constancia {it.policy} · abierta {it.opened_at}
              </div>
            </div>
            <div style={{ textAlign: 'right' }}>
              <div className="text-mono" style={{ fontSize: 14, fontWeight: 600, marginBottom: 4 }}>
                {fmtMoney(it.amount)}
              </div>
              <StatusPill status={it.status}/>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

// ===== Carrier breakdown (mini bars) =====
function CarrierBreakdown() {
  const data = [
    { name: 'FedEx', count: 1842, pct: 42 },
    { name: 'DHL', count: 1241, pct: 28 },
    { name: 'Estafeta', count: 720, pct: 16 },
    { name: 'Paquetexpress', count: 412, pct: 9 },
    { name: 'Otras', count: 177, pct: 5 },
  ];
  const colors = ['#1e40af', '#4f46e5', '#6366f1', '#818cf8', '#c7d2fe'];
  return (
    <div className="card" style={{ padding: 24 }}>
      <h3 style={{ fontSize: 16, fontWeight: 600, margin: 0, letterSpacing: '-0.01em' }}>Paqueterías</h3>
      <div className="text-mono" style={{ fontSize: 11, color: 'var(--fg-muted)', marginTop: 4, marginBottom: 20 }}>
        Distribución últimos 30 días
      </div>
      {/* stacked bar */}
      <div style={{ display: 'flex', height: 8, borderRadius: 100, overflow: 'hidden', marginBottom: 20 }}>
        {data.map((d, i) => (
          <div key={d.name} style={{ width: `${d.pct}%`, background: colors[i] }}/>
        ))}
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        {data.map((d, i) => (
          <div key={d.name} className="flex items-center gap-3">
            <span style={{ width: 10, height: 10, borderRadius: 3, background: colors[i] }}/>
            <span style={{ flex: 1, fontSize: 13, color: 'var(--fg-secondary)' }}>{d.name}</span>
            <span className="text-mono" style={{ fontSize: 12, color: 'var(--fg-muted)' }}>{fmtNum(d.count)}</span>
            <span className="text-mono" style={{ fontSize: 12, color: 'var(--fg)', fontWeight: 600, width: 36, textAlign: 'right' }}>
              {d.pct}%
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}

// ===== Dashboard Home =====
export default function DashboardPage() {
  const session = JSON.parse(localStorage.getItem('aps_session') || 'null');
  const data = MOCK_DASHBOARD;
  const user = {
    name: data.client.name,
    email: data.client.email,
    company_name: data.client.company_name,
  };

  const onLogout = () => {
    localStorage.removeItem('aps_session');
    window.location.hash = '#/';
  };

  // Smart greeting
  const hour = new Date().getHours();
  const greet = hour < 12 ? 'Buenos días' : hour < 19 ? 'Buenas tardes' : 'Buenas noches';
  const firstName = user.name.split(' ')[0];

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: 'var(--bg-soft)' }}>
      <Sidebar user={user} onLogout={onLogout}/>
      <main style={{ flex: 1, minWidth: 0 }}>
        <Topbar user={user}/>
        <div className="r-dash-main" style={{ padding: '32px 32px 64px' }}>
          {/* Header */}
          <div className="flex items-center justify-between" style={{ marginBottom: 32 }}>
            <div>
              <div className="text-mono" style={{ fontSize: 11, color: 'var(--fg-muted)', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: 8 }}>
                {new Date().toLocaleDateString('es-MX', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })}
              </div>
              <h1 style={{ fontSize: 28, fontWeight: 600, margin: 0, letterSpacing: '-0.025em' }}>
                {greet}, {firstName}.
              </h1>
              <p className="secondary" style={{ fontSize: 14, marginTop: 6, marginBottom: 0 }}>
                Aquí está el resumen de tu actividad de hoy.
              </p>
            </div>
            <div className="flex items-center gap-2">
              <button className="btn btn-secondary btn-sm">
                <Icon name="refresh" size={14}/> Actualizar
              </button>
              <button className="btn btn-secondary btn-sm">
                Últimos 30 días <Icon name="chevron-down" size={14}/>
              </button>
            </div>
          </div>

          {/* Top stats */}
          <div className="r-dash-stats">
            <StatCard
              label="Saldo disponible" icon="wallet" color="#1e40af"
              value={fmtMoney(data.client.balance)}
              sub="Recarga automática activa · próx. corte 15 may"/>
            <StatCard
              label="Protegido este mes" icon="shield-check" color="#059669"
              value={fmtMoney(data.statistics.insured_this_month)}
              change={data.statistics.monthly_change_pct}
              sub={`${fmtNum(data.statistics.policies_this_month)} protecciones emitidas`}/>
            <StatCard
              label="Protecciones activas" icon="package" color="#7c3aed"
              value={fmtNum(data.statistics.active_policies)}
              sub={`${data.statistics.expired_policies} vencidas · ${data.statistics.pending_policies} pendientes`}/>
            <StatCard
              label="Reclamaciones abiertas" icon="alert-triangle" color="#b45309"
              value={data.statistics.open_claims}
              sub={`SLA promedio · 1.8 días`}/>
          </div>

          {/* Chart + carrier */}
          <div className="r-dash-row">
            <div className="card" style={{ padding: 24 }}>
              <div className="flex items-center justify-between" style={{ marginBottom: 8 }}>
                <div>
                  <h3 style={{ fontSize: 16, fontWeight: 600, margin: 0, letterSpacing: '-0.01em' }}>
                    Valor protegido mensual
                  </h3>
                  <div className="text-mono" style={{ fontSize: 11, color: 'var(--fg-muted)', marginTop: 4 }}>
                    Últimos 7 meses · MXN
                  </div>
                </div>
                <div className="flex items-center gap-4 text-mono" style={{ fontSize: 11, color: 'var(--fg-muted)' }}>
                  <span className="flex items-center gap-2">
                    <span style={{ width: 8, height: 8, borderRadius: '50%', background: 'var(--brand)' }}/>
                    Valor protegido
                  </span>
                </div>
              </div>
              <div style={{ marginTop: 16 }}>
                <MonthlyChart data={data.monthly_chart}/>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16, marginTop: 24, paddingTop: 20, borderTop: '1px solid var(--border-faint)' }}>
                <Stat2 label="Total protegido" value={fmtMoney(data.statistics.total_insured_amount)}/>
                <Stat2 label="Protecciones totales" value={fmtNum(data.statistics.total_policies)}/>
                <Stat2 label="Costo promedio" value={fmtMoney(data.statistics.avg_premium)}/>
              </div>
            </div>
            <CarrierBreakdown/>
          </div>

          {/* Recent policies */}
          <div style={{ marginBottom: 24 }}>
            <RecentPolicies rows={data.recent_policies}/>
          </div>

          {/* Bottom: claims + activity */}
          <div className="r-dash-bottom">
            <ActiveClaims items={data.active_claims}/>
            <ActivityFeed items={data.latest_transactions}/>
          </div>
        </div>
      </main>
    </div>
  );
}

function Stat2({ label, value }) {
  return (
    <div>
      <div className="text-mono" style={{ fontSize: 10, color: 'var(--fg-muted)', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: 6 }}>
        {label}
      </div>
      <div style={{ fontSize: 18, fontWeight: 600, letterSpacing: '-0.02em' }}>{value}</div>
    </div>
  );
}
